export default {
  id: 'problemDescription/CHIEF_COMPLAINT/v1',
  formSchema: {
    title: 'encounter:widget.problemDescription.chiefComplaint',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.problemDescription.chiefComplaint',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
